// extracted by mini-css-extract-plugin
export var benefits_anchor = "solutions-module--benefits_anchor--GX5XB";
export var capabilities_anchor = "solutions-module--capabilities_anchor--IWyPE";
export var contact_us_anchor = "solutions-module--contact_us_anchor--qNPSx";
export var features_anchor = "solutions-module--features_anchor--24HoO";
export var img_container_col = "solutions-module--img_container_col--90hEj";
export var intro_header = "solutions-module--intro_header--sbrt9";
export var intro_image = "solutions-module--intro_image--XoTUd";
export var intro_image_container = "solutions-module--intro_image_container--ZsFq7";
export var solutions_anchor = "solutions-module--solutions_anchor--iYPhq";